/**
 * marsco开户没有年收入和总资产等限制条件
 */

import { FC } from 'react';
import { connect } from 'react-bootstrap-formutil';
import Debug from 'components/Debug';
import FormGroup from 'components/FormGroup';
import FormSelect from 'components/FormSelect';
import { isEmptyValue } from 'utils/helper';
import { printf } from 'utils/i18n';
import { netAssetsOptions, netCurAssetsOptions, netYearIncomeOptions, stkKlOptions } from './helper';
import { AssetsInfoProps } from './type';

const AssetsInfo: FC<AssetsInfoProps> = props => {
    const { disabled, $formutil } = props;
    const { $params } = $formutil;

    const $validators = {
        // 资产比较校验
        greater: (value, name, { validMessage }) => {
            // https://tigertech.feishu.cn/wiki/MjI0wsbC5iuw2aksv9Wc3voVnZd 第8条增加了marsco的净资产的比较规则
            // net_assets应该大于等于net_current_assets
            if (value && $params[name]) {
                const netAssetsLevel = netAssetsOptions.find(i => i.value === value)?.level;
                const netCurAssetsLevel = netCurAssetsOptions.find(i => i.value === $params[name])?.level;

                // 如果两个比较的Level都存在，且net_assets < net_current_assets
                // 前面判断过两个值不为empty了, 所以后面可以使用非空断言
                if (
                    [netAssetsLevel, netCurAssetsLevel].every(i => !isEmptyValue(i)) &&
                    netAssetsLevel! < netCurAssetsLevel!
                ) {
                    return validMessage.greater;
                }
            }

            return true;
        }
    };

    return (
        <div className="asset-root">
            <h4 className="mt-4 mb-3">{__('Assets and Income')}</h4>
            <FormGroup
                name="net_current_assets"
                label={__('Liquid Net Worth')}
                required
                $onFieldChange={() => $formutil.$validates()}
                validMessage={{
                    required: printf(__('Please select your %s'), __('liquid net worth'))
                }}>
                <FormSelect placeholder={__('Please Select')} disabled={disabled} options={netCurAssetsOptions} />
            </FormGroup>
            <FormGroup
                name="net_assets"
                required
                $validators={$validators}
                $onFieldChange={() => $formutil.$validates()}
                greater="net_current_assets"
                validMessage={{
                    required: printf(__('Please select your %s'), __('estimated net worth')),
                    greater: __('Your Net Worth cannot be smaller than Liquid Net Worth.')
                }}
                label={__('Estimated Net Worth')}>
                <FormSelect placeholder={__('Please Select')} disabled={disabled} options={netAssetsOptions} />
            </FormGroup>
            <FormGroup
                name="net_year_income"
                required
                $validators={$validators}
                $onFieldChange={() => $formutil.$validates()}
                validMessage={{
                    required: printf(__('Please select your %s'), __('Annual net income'))
                }}
                label={__('Annual Net Income')}>
                <FormSelect placeholder={__('Please Select')} disabled={disabled} options={netYearIncomeOptions} />
            </FormGroup>
            <FormGroup
                name="stk_kl"
                required
                label={__('Investment Experience')}
                validMessage={{
                    required: printf(__('Please select your %s'), __('Investment Experience'))
                }}>
                <FormSelect placeholder={__('Please Select')} disabled={disabled} options={stkKlOptions} />
            </FormGroup>
            <Debug data={$formutil.$errors} disabled />
        </div>
    );
};

export default connect(AssetsInfo);
export * from './type';
export * from './helper';
